/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface WorkflowTransition { 
    id?: string;
    points?: Array<number>;
    deleted?: boolean;
    workflow_id?: string;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    name?: string;
    description?: string;
    from_activity_unique_id?: string;
    to_activity_unique_id?: string;
    unique_id?: string;
    next_direction?: boolean;
    timer?: number;
    transition_type?: string;
}